<template>
    <div class="container text-center" style="max-width: 400px;">
        <h3 class="text-white m-5 text-center"><i>{{this.text ? this.text : $t('sito_manutenzione')}}</i></h3>
        <div class="text-center p-5 f11 text-white">
            Sei il ristoratore?
            <br>
            Accedi con il tuo codice Maintenance privato.
            <form @submit.prevent="submitPassword">
                <input
                    v-model.trim="password"
                    type="password"
                    class="form-control"
                    autocomplete="current-password"
                    :disabled="loading"
                >
                <button class="btn btn-light btn-sm mt-3" type="submit" :disabled="loading || !password">
                    {{ loading ? 'Verifica...' : 'Entra' }}
                </button>
            </form>
            <div v-if="errorMessage" class="mt-3 text-warning">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import { checkMaintenancePassword } from '../api/restaurant';

    export default {
        props: ['text', 'idRistorante', 'language'],
        data() {
            return {
                password: '',
                loading: false,
                errorMessage: null
            };
        },
        methods: {
            async submitPassword() {
                if (!this.password || this.loading) {
                    return;
                }

                this.loading = true;
                this.errorMessage = null;

                const password = this.password.trim().toUpperCase();

                try {
                    await checkMaintenancePassword(this.language, {
                        id_ristorante: this.idRistorante,
                        password
                    });
                    this.$emit('maintenance-unlocked');
                } catch ({messages}) {
                    if (messages && messages.length) {
                        this.errorMessage = messages.join('\n');
                    } else {
                        this.errorMessage = 'Password non valida.';
                    }
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>
